import { makeAutoObservable } from "mobx";
import { IRootStore } from "./RootStore";

type Conversation = {
    you: string;
    response: string;
  };
  
  type DataItem = {
    [id: number]: Conversation[];
  };
  
  type DataArray = DataItem[];
  
export class AssistantStore {
    loading: boolean = false;
    showChatBot: boolean = false;
    prompt: string = "";
    aiResponse: string = "";
    talkHistory: DataArray = [];
    expandHover: boolean = false;

    rootStore: IRootStore;
    constructor(rootStore: IRootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    setExpand = (isExpand: boolean) => {
        this.expandHover = isExpand;
    }
    get getExpand() {
        return this.expandHover;
    }

    setPrompt = (queries: string) => {
        this.prompt = queries;
    }
    get getPrompt() {
        return this.prompt;
    }

    setAiResponse = (queries: string) => {
        this.aiResponse = queries;
    }
    get getAiResponse() {
        return this.aiResponse;
    }

    setTalkHistory = (history: DataArray) => {
        this.talkHistory = history;
    }
    get getTalkHistory() {
        return this.talkHistory;
    }

    setShowChatBot = (isShowBot: boolean) => {
        this.showChatBot = isShowBot;
    }
    get getShowChatBot() {
        return this.showChatBot;
    }

    setLoading = (isShowBot: boolean) => {
        this.loading = isShowBot;
    }
    get getLoading() {
        return this.loading;
    }
    
}